module.exports = __webpack_public_path__ + "static/Refactr _Prospectus_2019-4661120363220df12649c5a6cf83f45e.pdf";